import { Box } from "@mui/material"
import { Editor, Frame as CraftFrame, useEditor } from '@craftjs/core';
import { CButton } from "../../components/craftjs/CButton"
import { CContainer } from "../../components/craftjs/CContainer"
import { CText } from "../../components/craftjs/CText"
import { CCard, CCardBottom, CCardTop } from "../../components/craftjs/CCard"
import { CImage } from "../../components/craftjs/CImage";
import { CDrawUpModal } from "../../components/craftjs/CDrawUpModal";
import { useEffect, useRef, useState } from "react";
import { CInput } from "../../components/craftjs/CInput";
import { TemplateData } from "../../types";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";
import { CLink } from "../../components/craftjs/CLink";
import { CForm } from "../../components/craftjs/CForm";
import { CSelectBox } from "../../components/craftjs/CSelectBox";
import { CFAQ } from "../../components/craftjs/CFAQ";
import { CTable } from "../../components/craftjs/CTable";
import { CCarousel } from "../../components/craftjs/CCarousel";

interface QueryProviderProps {
  onSaveQuery: (query: any) => void;
  onSaveActions: (actions: any) => void;
}

const QueryProvider = ({ onSaveQuery, onSaveActions }: QueryProviderProps) => {
  const { query, actions } = useEditor();

  useEffect(() => {
    onSaveQuery((currentQuery: any) => {
      if (currentQuery !== query) {
        return query;
      }
      return currentQuery;
    });
  }, [query, onSaveQuery]);

  useEffect(() => {
    onSaveActions((currentActions: any) => {
      if (currentActions !== actions) {
        return actions;
      }
      return currentActions;
    });
  }, [query, onSaveActions]);

  return null;
};

interface TemplateViewrProps {
  template_id: any;
}

export const TemplateViewr = ({ template_id } : TemplateViewrProps) => {
  const [template, setTemplate] = useState<TemplateData>({});
  const { fetchData } = useAPI();
  const [state, setState] = useState<any>(null);
  const [query, setQuery] = useState<any | null>(null);
  const [actions, setActions] = useState<any | null>(null);
  const isLoading = useRef(false);

  useEffect(() => {
    if (!isLoading.current && template_id && template_id != '') {
      isLoading.current = true;

      fetchData(`/templates/${template_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setTemplate(data);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [template_id]);

  useEffect(() => {
    if (actions) {
      actions.setOptions((options: any) => (options.enabled = false));
      if (template && template.content && template.content != '') {
        try {
          const json = JSON.parse(template.content);
          actions.deserialize(json);
        } catch (e: any) {
          console.error(e);
        }
      }
    }
  }, [actions, template])
  
  return (
    <Box>
      <Editor
        resolver={{
          CButton,
          CContainer,
          CForm,
          CText,
          CLink,
          CInput,
          CSelectBox,
          CCard,
          CCardTop,
          CCardBottom,
          CImage,
          CDrawUpModal,
          CFAQ,
          CTable,
          CCarousel,
        }}
      >
        <Box>
          <QueryProvider onSaveActions={setActions} onSaveQuery={setQuery} />
          <CraftFrame>
          </CraftFrame>
        </Box>
      </Editor>
    </Box>
  )
}
